import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithBackground.js";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro";
import { FiShield, FiZap, FiSmartphone, FiRefreshCw, FiBarChart2, FiBell } from "react-icons/fi";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;
const ContentWithPaddingXl = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24 px-4 sm:px-6 lg:px-8`;
const ContentWithVerticalPadding = tw.div`py-20 lg:py-24`;
const Content2Xl = tw.div`max-w-screen-2xl mx-auto`;

const Heading = tw.h1`font-bold text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-gray-900 leading-tight`;
const HeadingRow = tw.div`flex flex-col items-center text-center`;
const Text = tw.div`mt-8 text-base text-gray-600 max-w-3xl mx-auto`;

const FeatureGrid = tw.div`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12`;
const Feature = tw.div`bg-white rounded-lg shadow-lg p-8`;
const FeatureIcon = tw.div`text-primary-500 text-4xl mb-4`;
const FeatureTitle = tw.h3`text-xl font-semibold text-gray-900 mb-2`;
const FeatureDescription = tw.p`text-gray-600`;

const PricingSection = tw.div`mt-16`;
const PricingGrid = tw.div`grid grid-cols-1 md:grid-cols-3 gap-8 mt-8`;
const PricingCard = tw.div`bg-white rounded-lg shadow-lg p-8`;
const PricingTitle = tw.h3`text-xl font-semibold text-gray-900 mb-2`;
const PricingPrice = tw.div`text-3xl font-bold text-primary-500 mb-4`;
const PricingFeatures = tw.ul`space-y-2 mb-6`;
const PricingFeature = tw.li`flex items-center text-gray-600`;
const PricingButton = tw.button`w-full py-3 bg-primary-500 text-white rounded-lg font-medium tracking-wide text-sm transition duration-300 transform focus:outline-none focus:shadow-outline hover:bg-primary-600 hover:shadow-lg`;

export default () => {
  const features = [
    {
      icon: <FiShield />,
      title: "Sécurité Maximale",
      description: "Vos visites sont sécurisées grâce à l'identification numérique et au suivi en temps réel."
    },
    {
      icon: <FiZap />,
      title: "Check-in Rapide",
      description: "Enregistrez-vous en un instant grâce à la pré-inscription et à l'utilisation de QR codes ou de votre numéro de téléphone."
    },
    {
      icon: <FiSmartphone />,
      title: "Expérience Moderne",
      description: "Gérez vos visites, accédez à votre historique et recevez vos invitations directement sur votre mobile."
    },
    {
      icon: <FiRefreshCw />,
      title: "Enregistrement Unique",
      description: "Plus besoin de remplir vos informations à chaque visite : un seul enregistrement suffit."
    },
    {
      icon: <FiBarChart2 />,
      title: "Historique Personnel",
      description: "Consultez l'historique de vos passages et vos accès en toute simplicité."
    },
    {
      icon: <FiBell />,
      title: "Notifications Instantanées",
      description: "Recevez des notifications pour chaque visite programmée ou validée."
    }
  ];

  const pricingPlans = [
    {
      title: "Gratuit",
      price: "0 FCFA",
      features: [
        "Check-in rapide avec QR code ou numéro de téléphone",
        "Historique personnel des visites",
        "Notifications de rendez-vous",
        "Support de base"
      ]
    },
    {
      title: "Pro",
      price: "15 000 FCFA/mois",
      features: [
        "Toutes les fonctionnalités du plan Gratuit",
        "Gestion avancée des invitations",
        "Support prioritaire",
        "Accès à des rapports personnalisés"
      ]
    },
    {
      title: "Premium",
      price: "30 000 FCFA/mois",
      features: [
        "Toutes les fonctionnalités du plan Pro",
        "Accès VIP et check-in express",
        "Gestion multi-sites",
        "Assistance dédiée"
      ]
    }
  ];

  return (
    <AnimationRevealPage>
      <Header />
      <Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>Compte Visiteur Personnel</Heading>
          </HeadingRow>
          <Text>
            <p className="text-center mb-8">
              Tanga révolutionne votre expérience de visite : sécurité, rapidité et simplicité. Pré-inscrivez-vous, accédez facilement à vos rendez-vous et profitez d'un check-in sans attente dans toutes les entreprises équipées de Tanga.
            </p>
          </Text>

          <FeatureGrid>
            {features.map((feature, index) => (
              <Feature key={index}>
                <FeatureIcon>{feature.icon}</FeatureIcon>
                <FeatureTitle>{feature.title}</FeatureTitle>
                <FeatureDescription>{feature.description}</FeatureDescription>
              </Feature>
            ))}
          </FeatureGrid>

          {/* <PricingSection>
            <HeadingRow>
              <Heading>Nos Offres</Heading>
            </HeadingRow>
            <Text>
              <p className="text-center mb-8">
                Choisissez l'offre qui correspond le mieux à vos besoins et commencez votre voyage vers le succès professionnel.
              </p>
            </Text>

            <PricingGrid>
              {pricingPlans.map((plan, index) => (
                <PricingCard key={index}>
                  <PricingTitle>{plan.title}</PricingTitle>
                  <PricingPrice>{plan.price}</PricingPrice>
                  <PricingFeatures>
                    {plan.features.map((feature, featureIndex) => (
                      <PricingFeature key={featureIndex}>
                        <span className="mr-2">✓</span>
                        {feature}
                      </PricingFeature>
                    ))}
                  </PricingFeatures>
                  <PricingButton>S'inscrire</PricingButton>
                </PricingCard>
              ))}
            </PricingGrid>
          </PricingSection> */}
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
}; 